import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import { StyleRegulationForm } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import Risk from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Risk';
import { Grid } from '@material-ui/core';
import { Listings } from 'containers/AppContainer/typings';
import { get } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { ClaimRecapType } from 'typings/claimTypes';

export interface RegulationFormProps {
  intl: IntlShape;
  sagisClaim: any;
  claimRecap: ClaimRecapType;
  setRiskRecap: any;
  riskRecap: any;
  listings: Listings;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVehicles: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  requestCreateCorpoEncryptedDocument: Function;
  corporealEncryptedDocuments: any;
  setShowSideRecap: Function;
  showSideRecap: boolean;
  substituteDocumentNature: any;
  setSubstituteDocumentNature: Function;
  setShowRegulationJudgement: Function;
  requestCreateCorporealRegulation: Function;
  requestCreateMaterialRegulation: Function;
  requestCreateAdditionalWarrentiesRegulation: Function;
  setHeight: Function;
  requestMaterialEncryptedDocument: Function;
  materialEncryptedDocuments: any;
  requestGetAssignedLawyers: Function;
  assignedLawyers: AssignedLawyer[];
  requestSagisClaimInfo: Function;
  requestGetDahirAmount: Function;
  requestGetDahirAmountCorpo: Function;
  dahirAmount: any;
  dahirAmountsCorpo: any;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  uploadedDocument: IUploadedDocument;
  requestValidateProvisionIntervenant: Function;
  createdRegulations: any;
  requestCreateSummarySheetRegulation: Function;
  uploadDocumentRegulation: Function;
  corpoRegulations: any;
  policyInfo: any;
  requestValidateProvision: Function;
  lastSagisClaim: any;
  isBasicManagementRegulation?: boolean;
}

export const RegulationForm: React.FC<RegulationFormProps> = ({
  sagisClaim,
  claimRecap,
  setRiskRecap,
  riskRecap,
  judgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVictims,
  judgementOnMeritsByVehicles,
  requestGetJudgementOnMeritsByVehicles,
  corporealEncryptedDocuments,
  showSideRecap,
  setShowSideRecap,
  substituteDocumentNature,
  setSubstituteDocumentNature,
  setShowRegulationJudgement,
  setHeight,
  ...props
}): JSX.Element => {
  const ref = useRef(null);
  const [activeStep, setActiveStep] = useState(0);
  useEffect(() => {
    setHeight(get(ref, 'current.clientHeight', null));
  }, [activeStep]);
  return (
    <main>
      <StyleRegulationForm showSideRecap={showSideRecap} ref={ref}>
        <Grid className="content">
          <span className="title">
            {showSideRecap
              ? translate(messages.regulationRequestTitle, props)
              : translate(messages.regulationRecapTitle, props)}
          </span>
        </Grid>
        <Grid>
          <Risk
            sagisClaim={sagisClaim}
            claimRecap={claimRecap}
            setRiskRecap={setRiskRecap}
            riskRecap={riskRecap}
            listings={props.listings}
            requestGetJudgementOnMeritsByVictims={
              requestGetJudgementOnMeritsByVictims
            }
            judgementOnMeritsByVictims={get(
              judgementOnMeritsByVictims,
              'judgement',
              [],
            )}
            judgementOnMeritsWithCivjvm={get(
              judgementOnMeritsByVictims,
              'judgementsWithCivjvm',
              [],
            )}
            judgementOnMeritsByVehicles={judgementOnMeritsByVehicles}
            requestGetJudgementOnMeritsByVehicles={
              requestGetJudgementOnMeritsByVehicles
            }
            requestCreateCorpoEncryptedDocument={
              props.requestCreateCorpoEncryptedDocument
            }
            corporealEncryptedDocuments={corporealEncryptedDocuments}
            setShowSideRecap={setShowSideRecap}
            setSubstituteDocumentNature={setSubstituteDocumentNature}
            substituteDocumentNature={substituteDocumentNature}
            setShowRegulationJudgement={setShowRegulationJudgement}
            requestCreateCorporealRegulation={
              props.requestCreateCorporealRegulation
            }
            requestCreateMaterialRegulation={
              props.requestCreateMaterialRegulation
            }
            requestCreateAdditionalWarrentiesRegulation={
              props.requestCreateAdditionalWarrentiesRegulation
            }
            requestMaterialEncryptedDocument={
              props.requestMaterialEncryptedDocument
            }
            materialEncryptedDocuments={props.materialEncryptedDocuments}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            requestGetAssignedLawyers={props.requestGetAssignedLawyers}
            assignedLawyers={props.assignedLawyers}
            requestSagisClaimInfo={props.requestSagisClaimInfo}
            requestGetDahirAmount={props.requestGetDahirAmount}
            requestGetDahirAmountCorpo={props.requestGetDahirAmountCorpo}
            dahirAmountsCorpo={props.dahirAmountsCorpo}
            dahirAmount={props.dahirAmount}
            uploadDocument={props.uploadDocument}
            resetUploadDocumentStore={props.resetUploadDocumentStore}
            uploadedDocument={props.uploadedDocument}
            requestValidateProvisionIntervenant={
              props.requestValidateProvisionIntervenant
            }
            createdRegulations={props.createdRegulations}
            requestCreateSummarySheetRegulation={
              props.requestCreateSummarySheetRegulation
            }
            uploadDocumentRegulation={props.uploadDocumentRegulation}
            corpoRegulations={props.corpoRegulations}
            policyInfo={props.policyInfo}
            requestValidateProvision={props.requestValidateProvision}
            lastSagisClaim={props.lastSagisClaim}
            isBasicManagementRegulation={props.isBasicManagementRegulation}
            judgementNatureProcedureIds={get(
              judgementOnMeritsByVictims,
              'judgementprocedureNatureIds',
              [],
            )}
          />
        </Grid>
      </StyleRegulationForm>
    </main>
  );
};

export default injectIntl(RegulationForm);
